const Heart = () => (
  <svg viewBox="0 0 24 24" className="w-4 h-4 md:w-5 md:h-5 text-brandred mx-4 shrink-0" fill="currentColor" aria-hidden="true">
    <path d="M12 21s-7.5-4.9-9.7-9.2C.7 8.6 2.6 4.9 6.2 4.9c2.2 0 3.9 1.3 4.8 3 .9-1.7 2.6-3 4.8-3 3.6 0 5.5 3.7 3.9 6.9C19.5 16.1 12 21 12 21Z" />
  </svg>
);

const Strip = () => (
  <div className="flex shrink-0 items-center">
    {Array.from({ length: 6 }).map((_, i) => (
      <span key={i} className="flex items-center whitespace-nowrap">
        <Heart />
        <span className="font-display text-2xl md:text-3xl text-navy">EVERY SETTLEMENT IS SOMEONE'S TOMORROW</span>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div data-testid="tagline-marquee" className="overflow-hidden border-y-2 border-navy py-2 bg-cream">
    <div className="marquee-track flex w-max">
      <Strip />
      <Strip />
    </div>
  </div>
);

export default Marquee;
